PJQ.models.drawings.Annotation = PJQ.models.BaseModel.extend({
    idAttribute: 'annotationId',
    notifyName: 'Annotation',
    minWidth: 0,
    minHeight: 0,
    afterInit: function () {
        if (PJQ.helpers.objectHelpers.checkNested(PJQ.app, 'session', 'preferences')) {
            this.options.isAPIv2 = PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_DRAWING_ANNOTATION_REFS);
        }
    },
    endpoint: function (options) {
        if (!options) {
            options = {};
        }

        options.isAPIv2 = this.options.isAPIv2 = [PJQ.constants.drawings.annotationTypes.PIN_RFI,
            PJQ.constants.drawings.annotationTypes.PIN_PUNCH_LIST_ITEM,
            PJQ.constants.drawings.annotationTypes.PIN_ACTION_ITEM,
            PJQ.constants.drawings.annotationTypes.PIN_SUBMITTAL].indexOf(this.get('type')) !== -1;

        if (this.id > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'drawings'
                },
                {
                    endpoint: 'annotations',
                    value: this.id
                }
            ]);
        }
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'drawings',
                value: this.get('drawingId')
            },
            {
                endpoint: 'annotations'
            }
        ]);
    },
    canEdit: function () {
        return (PJQ.app.session.user != null && this.get('userId') === -PJQ.app.session.user.id) || this.get('canEdit');
    },
    canEditColor: function (type) {
        if (type == null) {
            type = this.get('type');
        }
        return type !== PJQ.constants.drawings.annotationTypes.PIN_PUNCH_LIST_ITEM && type !== PJQ.constants.drawings.annotationTypes.PIN_ACTION_ITEM
            && type !== PJQ.constants.drawings.annotationTypes.PIN_RFI && type !== PJQ.constants.drawings.annotationTypes.PIN_SUBMITTAL;
    },
    parse: function (model) {
        if (!model) {
            return model;
        }

        if (_.size(model.attachments) > 0) {
            this.attachments = new PJQ.collections.drawings.AnnotationAttachments(model.attachments);
        } else if (this.attachments == null) {
            this.attachments = new PJQ.collections.drawings.AnnotationAttachments();
        }

        if (model.refData && model.refId > 0) {
            switch (model.refType) {
                case PJQ.constants.drawings.refTypes.PUNCH_LIST_ITEM:
                    model.refData.punchlistItemId = model.refId;
                    this.punchListItem = new PJQ.models.punchlists.PunchlistItem(model.refData);
                    break;
                case PJQ.constants.drawings.refTypes.ACTION_ITEM:
                    model.refData.actionItemId = model.refId;
                    this.actionItem = new PJQ.models.actionItems.ActionItem(model.refData);
                    break;
            }
        }

        return model;
    },
    getDisplayName: function () {
        return '';
    },
    getDeepLink: function () {
        return null;
    },
    drawDragPoints: function (ct, scale) {
        this.dragPoints = [];
    },
    getStrokeColor: function () {
        return this.get('color');
    },
    stroke: function (ct, scale) {
        let strokeColor = this.getStrokeColor();
        if (strokeColor) {
            ct.lineWidth = 6 / scale;
            ct.setLineDash([0]);
            ct.strokeStyle = strokeColor;
            ct.stroke();
        }
    },
    getFillColor: function () {
        return this.get('color') + '75';
    },
    fill: function (ct) {
        let fillColor = this.getFillColor();
        if (fillColor) {
            ct.fillStyle = fillColor;
            ct.fill();
        }
    },
    start: function (x, y) {
        this.set({
            start: {
                x: Math.round(x),
                y: Math.round(y)
            }
        });

        if (this.attributes.end == null) {
            this.end(x, y);
        }
    },
    end: function (x, y, normalize = false) {
        this.set({
            end: {
                x: Math.round(x),
                y: Math.round(y)
            }
        });

        if (normalize) {
            this.normalizeCoords();
        }

        if (this.minHeight > this.attributes.end.y - this.attributes.start.y) {
            this.attributes.end.y = this.attributes.start.y + this.minHeight;
        }

        if (this.minWidth > this.attributes.end.x - this.attributes.start.x) {
            this.attributes.end.x = this.attributes.start.x + this.minWidth;
        }
    },
    move: function (xDiff, yDiff, maxX, maxY) {
        let start = this.attributes.start,
            end = this.attributes.end,
            newStartX = start.x + xDiff,
            newStartY = start.y + yDiff,
            newEndX = end.x + xDiff,
            newEndY = end.y + yDiff;

        if (newStartX < 0) {
            newEndX -= newStartX;
            newStartX = 0;
        } else if (newEndX >= maxX) {
            newStartX -= newEndX - maxX;
            newEndX = maxX;
        }

        if (newStartY < 0) {
            newEndY -= newStartY;
            newStartY = 0;
        } else if (newEndY >= maxY) {
            newStartY -= newEndY - maxY;
            newEndY = maxY;
        }

        this.start(newStartX, newStartY);
        this.end(newEndX, newEndY);
    },
    moveDragPoint: function (dragPoint, x, y) {
        let start = this.attributes.start,
            end = this.attributes.end;
        switch (dragPoint.position) {
            case PJQ.constants.drawings.dragPoints.TOP_LEFT:
            case PJQ.constants.drawings.dragPoints.START:
                this.start(x, y);
                break;
            case PJQ.constants.drawings.dragPoints.BOTTOM_RIGHT:
            case PJQ.constants.drawings.dragPoints.END:
                this.end(x, y);
                break;
            case PJQ.constants.drawings.dragPoints.TOP_RIGHT:
                this.start(start.x, y);
                this.end(x, end.y);
                break;
            case PJQ.constants.drawings.dragPoints.BOTTOM_LEFT:
                this.start(x, start.y);
                this.end(end.x, y);
                break;
        }
    },
    getCoords(scale = 1) {
        let coords = this.getNormalizedCoords();
        if (coords == null) {
            return null;
        }

        let startX = coords.start.x / scale,
            startY = coords.start.y / scale,
            endX = coords.end.x / scale,
            endY = coords.end.y / scale;
        return {
            start: {
                x: startX,
                y: startY
            },
            end: {
                x: endX,
                y: endY
            },
            height: endY - startY,
            width: endX - startX
        };
    },
    encodePath: function () {
        return null;
    },
    decodePath: function () {
        return null;
    },
    normalizeCoords: function () {
        this.set(this.getNormalizedCoords());
    },
    getNormalizedCoords: function () {
        let start = this.get('start'),
            end = this.get('end');
        if (start == null || end == null) {
            return null;
        }
        return {
            start: start,
            end: end
        };
    },
    collides: function (x, y) {
        return false;
    },
    getCollidingDragPoint: function (x, y) {
        if (this.dragPoints == null) {
            return null;
        }

        return _.find(this.dragPoints, function (point) {
            return PJQ.helpers.trigHelpers.checkRectCollision(point.start, point.end, x, y);
        });
    },
    beforeSave: function () {
        if (this.attachments) {
            this.set('attachments', this.attachments.getChangedModels());
        }
    },
    publish: function (callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'drawings'
                },
                {
                    endpoint: 'annotations',
                    value: this.id
                },
                {
                    endpoint: 'publish'
                }
            ]),
            data: this.toJSON()
        }).put().done(_.bind(function () {
            if (typeof callback === 'function') {
                callback();
            }
        }, this)).fail(_.bind(function () {
            this.set('isPublished', !this.get('isPublished'));
            if (typeof callback === 'function') {
                callback();
            }
        }, this));
    }
});

PJQ.models.drawings.Pen = PJQ.models.drawings.Annotation.extend({
    getDisplayName: function () {
        return PJQ.constants.drawings.annotationTypeNames.PEN;
    },
    start: function (x, y) {
        // start in the case of pen creates a points array and adds the coordinate as the start point
        if (_.size(this.attributes.path) > 0) {
            this.attributes.path[0][0] = x;
            this.attributes.path[0][1] = y;
        } else if (_.size(this.path) === 0) {
            this.path = [[Math.floor(x), Math.floor(y)]];
        }
    },
    end: function (x, y) {
        if (this.path != null) {
            this.path.push([Math.floor(x), Math.floor(y)]);
        } else {
            this.start(x, y);
        }
    },
    normalizeCoords: function (stopDrawing) {
        if (stopDrawing && _.size(this.path) > 0) {
            let smooth = [],
                threshold = 25,
                prevX = null,
                prevY = null;
            _.each(this.path, function (point, index) {
                // remove points which are less than 25 units away (x and y) from the previous point
                let thisX = point[0],
                    thisY = point[1],
                    isAdd = false;
                if (prevX != null && prevY != null) {
                    let xDiff = thisX - prevX,
                        yDiff = thisY - prevY;
                    if ((xDiff > threshold || xDiff < -threshold) || (yDiff > threshold || yDiff < -threshold))
                        isAdd = true;
                } else {
                    isAdd = true;
                }

                if (isAdd) {
                    prevX = thisX;
                    prevY = thisY;
                    smooth.push(point);
                }

                // take every 10th point to cut down the amount of data stored for the path
                // this method results in about a 5% reduction from the above method
                // the downside to this method is thicker lines look blocky
                // if (index % 10 === 0) {
                // 	smooth.push(point);
                // }
            });
            this.encodePath(smooth);
        }
    },
    moveDragPoint: function (dragPoint, x, y) {
        let pts = this.get('path');
        if (_.size(pts) > 0) {
            switch (dragPoint.position) {
                case PJQ.constants.drawings.dragPoints.START:
                    pts[0][0] = Math.floor(x);
                    pts[0][1] = Math.floor(y);
                    break;
                case PJQ.constants.drawings.dragPoints.END:
                    let decodedPts = this.decodePath();
                    pts[0][0] = Math.floor(pts[0][0] + x - decodedPts[decodedPts.length - 1][0]);
                    pts[0][1] = Math.floor(pts[0][1] + y - decodedPts[decodedPts.length - 1][1]);
                    break;
            }
            this.set('path', pts);
        }
    },
    encodePath: function (pts) {
        // delta encode each point x/y coordinate corresponding to the previous
        let path = [],
            prevX = null,
            prevY = null;
        if (_.size(pts) > 0) {
            _.each(pts, function (point, index) {
                let thisX = pts[index][0],
                    thisY = pts[index][1],
                    deltaX,
                    deltaY;
                if (prevX != null && prevY != null) {
                    deltaX = thisX - prevX;
                    deltaY = thisY - prevY;
                } else {
                    deltaX = thisX;
                    deltaY = thisY;
                }
                prevX = thisX;
                prevY = thisY;
                path.push([deltaX, deltaY]);
            }, this);
        }
        this.set('path', path);
        return path;
    },
    decodePath: function () {
        // delta encode each point x/y coordinate corresponding to the previous
        let pts = this.get('path'),
            path = [],
            prevX = null,
            prevY = null;
        if (_.size(pts) > 0) {
            _.each(pts, function (point, index) {
                let thisX = pts[index][0],
                    thisY = pts[index][1],
                    deltaX,
                    deltaY;
                if (prevX != null && prevY != null) {
                    deltaX = prevX + thisX;
                    deltaY = prevY + thisY;
                } else {
                    deltaX = thisX;
                    deltaY = thisY;
                }
                prevX = deltaX;
                prevY = deltaY;
                path.push([deltaX, deltaY]);
            }, this);
        }
        return path;
    },
    collides: function (x, y) {
        if (_.size(this.get('path')) > 0) {
            let path = this.decodePath(),
                buffer = 20,
                start = {
                    x: 0,
                    y: 0
                };
            for (let i = 0; i < _.size(path); i++) {
                let end = {
                    x: path[i][0],
                    y: path[i][1]
                };
                if (i > 0) {
                    let dStart = PJQ.helpers.trigHelpers.distance(start.x, start.y, x, y),
                        dEnd = PJQ.helpers.trigHelpers.distance(end.x, end.y, x, y),
                        dComb = dStart + dEnd,
                        lineLen = PJQ.helpers.trigHelpers.distance(start.x, start.y, end.x, end.y);
                    if (dComb >= lineLen - buffer && dComb <= lineLen + buffer) {
                        return true;
                    }
                }
                start = end;
            }
        }
        return false;
    },
    draw: function (ct, scale) {
        let path;
        if (_.size(this.get('path')) > 0) {
            path = this.decodePath();
        } else if (_.size(this.path) > 0) {
            path = this.path;
        } else {
            path = null;
        }
        if (path != null) {
            ct.beginPath();
            let startX = null,
                startY = null;
            _.each(path, function (point) {
                let pointX = point[0] / scale,
                    pointY = point[1] / scale;
                if (startX == null && startY == null) {
                    startX = pointX;
                    startY = pointY;
                    ct.moveTo(startX, startY);
                } else {
                    ct.lineTo(pointX, pointY);
                }
            });
            this.stroke(ct, scale);
        }
    },
    getCoords: function (scale) {
        let result = {
            start: {
                x: 0,
                y: 0
            },
            end: {
                x: 0,
                y: 0
            }
        };
        let path = this.decodePath(),
            ptCount = _.size(path);
        if (ptCount > 0) {
            result.start.x = path[0][0] / scale;
            result.start.y = path[0][1] / scale;
            if (ptCount > 1) {
                result.end.x = path[ptCount - 1][0] / scale;
                result.end.y = path[ptCount - 1][1] / scale;
            }
        }
        return result;
    },
    drawDragPoints: function (ct, scale) {
        let ptWidth = 15,
            coords = this.getCoords(scale),
            hfPtWidth = ptWidth / 2,
            sStartX = coords.start.x - hfPtWidth,
            sStartY = coords.start.y - hfPtWidth,
            eStartX = coords.end.x - hfPtWidth,
            eStartY = coords.end.y - hfPtWidth

        this.dragPoints = [
            {
                position: PJQ.constants.drawings.dragPoints.START,
                start: {
                    x: sStartX,
                    y: sStartY
                },
                end: {
                    x: sStartX + ptWidth,
                    y: sStartY + ptWidth
                }
            },
            {
                position: PJQ.constants.drawings.dragPoints.END,
                start: {
                    x: eStartX,
                    y: eStartY
                },
                end: {
                    x: eStartX + ptWidth,
                    y: eStartY + ptWidth
                }
            }
        ];

        ct.beginPath();
        ct.lineWidth = 3;
        ct.strokeStyle = '#343a40';
        ct.setLineDash([]);
        _.each(this.dragPoints, function (point) {
            ct.clearRect(point.start.x, point.start.y, ptWidth, ptWidth);
            PJQ.helpers.canvasHelpers.drawRoundRect(ct, point.start.x, point.start.y, ptWidth, ptWidth, 4, false, true)
        });
    }
});

PJQ.models.drawings.Highlighter = PJQ.models.drawings.Pen.extend({
    getDisplayName: function () {
        return PJQ.constants.drawings.annotationTypeNames.HIGHLIGHTER;
    },
    stroke: function (ct, scale) {
        let strokeColor = this.getStrokeColor();
        if (strokeColor) {
            let ts = this.get('textSize');
            ct.lineWidth = Math.max(20, ts ? ts : 0) / scale;
            ct.setLineDash([0]);
            let rgb = PJQ.helpers.colorHelpers.getRGBFromHex(strokeColor);
            ct.strokeStyle = 'rgba(' + rgb.R.toString() + ',' + rgb.G.toString() + ',' + rgb.B.toString() + ', 0.5)';
            ct.stroke();
        }
    },
});

PJQ.models.drawings.Line = PJQ.models.drawings.Annotation.extend({
    getDisplayName: function () {
        return PJQ.constants.drawings.annotationTypeNames.LINE;
    },
    end: function (x, y, normalize = false) {
        this.set({
            end: {
                x: Math.round(x),
                y: Math.round(y)
            }
        });

        if (normalize) {
            this.normalizeCoords();
        }
    },
    collides: function (x, y) {
        let start = this.get('start'),
            end = this.get('end');

        if (start == null || end == null) {
            return false;
        }

        let dStart = PJQ.helpers.trigHelpers.distance(start.x, start.y, x, y),
            dEnd = PJQ.helpers.trigHelpers.distance(end.x, end.y, x, y),
            dComb = dStart + dEnd,
            lineLen = PJQ.helpers.trigHelpers.distance(start.x, start.y, end.x, end.y),
            buffer = 20;
        if (dComb >= lineLen - buffer && dComb <= lineLen + buffer) {
            return true;
        }
    },
    draw: function (ct, scale) {
        let coords = this.getCoords(scale);
        if (coords == null) {
            return;
        }

        ct.beginPath();
        ct.moveTo(coords.start.x, coords.start.y);
        ct.lineTo(coords.end.x, coords.end.y);

        this.stroke(ct, scale);
    },
    drawDragPoints: function (ct, scale) {
        let ptWidth = 15,
            coords = this.getCoords(scale),
            hfPtWidth = ptWidth / 2,
            sStartX = coords.start.x - hfPtWidth,
            sStartY = coords.start.y - hfPtWidth,
            eStartX = coords.end.x - hfPtWidth,
            eStartY = coords.end.y - hfPtWidth

        this.dragPoints = [
            {
                position: PJQ.constants.drawings.dragPoints.START,
                start: {
                    x: sStartX,
                    y: sStartY
                },
                end: {
                    x: sStartX + ptWidth,
                    y: sStartY + ptWidth
                }
            },
            {
                position: PJQ.constants.drawings.dragPoints.END,
                start: {
                    x: eStartX,
                    y: eStartY
                },
                end: {
                    x: eStartX + ptWidth,
                    y: eStartY + ptWidth
                }
            }
        ];

        ct.beginPath();
        ct.lineWidth = 3;
        ct.strokeStyle = '#343a40';
        ct.setLineDash([]);
        _.each(this.dragPoints, function (point) {
            ct.clearRect(point.start.x, point.start.y, ptWidth, ptWidth);
            PJQ.helpers.canvasHelpers.drawRoundRect(ct, point.start.x, point.start.y, ptWidth, ptWidth, 4, false, true)
        });
    }
});

PJQ.models.drawings.Arrow = PJQ.models.drawings.Line.extend({
    getDisplayName: function () {
        return PJQ.constants.drawings.annotationTypeNames.ARROW;
    },
    draw: function (ct, scale) {
        let coords = this.getCoords(scale);
        if (coords == null) {
            return;
        }

        let headLength = 100 / scale,
            dx = coords.end.x - coords.start.x,
            dy = coords.end.y - coords.start.y,
            angle = Math.atan2(dy, dx);

        ct.beginPath();
        ct.moveTo(coords.start.x, coords.start.y);
        ct.lineTo(coords.end.x, coords.end.y);

        ct.lineTo(coords.end.x - headLength * Math.cos(angle - Math.PI / 6), coords.end.y - headLength * Math.sin(angle - Math.PI / 6));

        ct.moveTo(coords.end.x, coords.end.y);
        ct.lineTo(coords.end.x - headLength * Math.cos(angle + Math.PI / 6), coords.end.y - headLength * Math.sin(angle + Math.PI / 6));

        this.stroke(ct, scale);
    }
});

PJQ.models.drawings.Rectangle = PJQ.models.drawings.Annotation.extend({
    getDisplayName: function () {
        return PJQ.constants.drawings.annotationTypeNames.RECTANGLE;
    },
    minWidth: 100,
    minHeight: 100,
    getNormalizedCoords: function () {
        let start = this.get('start'),
            end = this.get('end');
        if (start == null || end == null) {
            return null;
        }

        let result = {
            start: start,
            end: end
        };
        if (start.x > end.x && start.y > end.y) {
            // starts at bottom right - swap end/start points
            result = {
                start: end,
                end: start
            };
        } else if (start.y > end.y) {
            // starts at bottom left
            result = {
                start: {
                    x: start.x,
                    y: end.y
                },
                end: {
                    x: end.x,
                    y: start.y
                }
            };
        } else if (start.x > end.x) {
            // starts at top right
            result = {
                start: {
                    x: end.x,
                    y: start.y
                },
                end: {
                    x: start.x,
                    y: end.y
                }
            };
        }
        return result;
    },
    collides: function (x, y) {
        let start = this.get('start'),
            end = this.get('end');

        if (start == null || end == null) {
            return false;
        }

        return PJQ.helpers.trigHelpers.checkRectCollision(start, end, x, y);
    },
    draw: function (ct, scale) {
        let coords = this.getCoords(scale);
        if (coords == null) {
            return;
        }

        ct.beginPath();
        ct.rect(coords.start.x, coords.start.y, coords.width, coords.height);

        this.stroke(ct, scale);

        if (typeof this.drawLink === 'function') {
            this.drawLink(ct, scale);
        }
    },
    drawDragPoints: function (ct, scale) {
        let ptWidth = 16,
            margin = 10 / scale,
            coords = this.getCoords(scale),
            tlStartX = coords.start.x - ptWidth - margin,
            tlStartY = coords.start.y - ptWidth - margin,
            brStartX = coords.end.x + margin,
            brStartY = coords.end.y + margin,
            trStartX = coords.end.x + margin,
            trStartY = coords.start.y - ptWidth - margin,
            blStartX = coords.start.x - ptWidth - margin,
            blStartY = coords.end.y + margin;

        ct.beginPath();
        ct.rect(tlStartX + (ptWidth / 2), tlStartY + (ptWidth / 2), brStartX - tlStartX, brStartY - tlStartY);
        ct.setLineDash([6]);
        ct.lineWidth = 3;
        ct.strokeStyle = '#343a40';
        ct.stroke()

        this.dragPoints = [{
            position: PJQ.constants.drawings.dragPoints.TOP_LEFT,
            start: {
                x: tlStartX,
                y: tlStartY
            },
            end: {
                x: tlStartX + ptWidth,
                y: tlStartY + ptWidth
            }
        }, {
            position: PJQ.constants.drawings.dragPoints.BOTTOM_RIGHT,
            start: {
                x: brStartX,
                y: brStartY
            },
            end: {
                x: brStartX + ptWidth,
                y: brStartY + ptWidth
            }
        }, {
            position: PJQ.constants.drawings.dragPoints.TOP_RIGHT,
            start: {
                x: trStartX,
                y: trStartY
            },
            end: {
                x: trStartX + ptWidth,
                y: trStartY + ptWidth
            }
        }, {
            position: PJQ.constants.drawings.dragPoints.BOTTOM_LEFT,
            start: {
                x: blStartX,
                y: blStartY
            },
            end: {
                x: blStartX + ptWidth,
                y: blStartY + ptWidth
            }
        }];

        ct.beginPath();
        ct.lineWidth = 3;
        ct.strokeStyle = '#343a40';
        ct.setLineDash([]);
        _.each(this.dragPoints, function (point) {
            ct.clearRect(point.start.x, point.start.y, ptWidth, ptWidth);
            PJQ.helpers.canvasHelpers.drawRoundRect(ct, point.start.x, point.start.y, ptWidth, ptWidth, 4, false, true)
        });
    }
});

PJQ.models.drawings.Ellipse = PJQ.models.drawings.Rectangle.extend({
    getDisplayName: function () {
        return PJQ.constants.drawings.annotationTypeNames.ELLIPSE;
    },
    draw: function (ct, scale) {
        let coords = this.getCoords(scale);
        if (coords == null) {
            return;
        }

        let radiusX = (coords.end.x - coords.start.x) * 0.5,
            radiusY = (coords.end.y - coords.start.y) * 0.5,
            centerX = coords.start.x + radiusX,
            centerY = coords.start.y + radiusY,
            step = 0.01,
            a = step,
            pi2 = Math.PI * 2 - step;

        ct.beginPath();
        ct.moveTo(centerX + radiusX * Math.cos(0), centerY + radiusY * Math.sin(0));
        for (; a < pi2; a += step) {
            ct.lineTo(centerX + radiusX * Math.cos(a),
                centerY + radiusY * Math.sin(a));
        }
        ct.closePath();

        this.stroke(ct, scale);

        if (typeof this.drawLink === 'function') {
            this.drawLink(ct, scale);
        }
    }
});

PJQ.models.drawings.Cloud = PJQ.models.drawings.Rectangle.extend({
    getDisplayName: function () {
        return PJQ.constants.drawings.annotationTypeNames.CLOUD;
    },
    draw: function (ct, scale) {
        let coords = this.getCoords(scale);
        if (coords == null) {
            return;
        }

        let lastX = coords.start.x,
            lastY = coords.start.y,
            bumpWidth = 60 / scale,
            bumpWidthHalf = bumpWidth / 2,
            bumpHeight = bumpWidth / 3;

        ct.beginPath();
        ct.moveTo(lastX, lastY);
        while (lastX < coords.end.x) {
            if (lastX + bumpWidth > coords.end.x) {
                let thisBumpWidth = coords.end.x - lastX,
                    thisBumpHeight = (thisBumpWidth / bumpWidth) * bumpHeight;
                ct.bezierCurveTo(lastX + (thisBumpWidth / 2), lastY - thisBumpHeight, lastX + (thisBumpWidth / 2), lastY - thisBumpHeight, coords.end.x, lastY);
                lastX = coords.end.x;
            } else {
                ct.bezierCurveTo(lastX + bumpWidthHalf, lastY - bumpHeight, lastX + bumpWidthHalf, lastY - bumpHeight, lastX + bumpWidth, lastY);
                lastX += bumpWidth;
            }
        }
        while (lastY < coords.end.y) {
            if (lastY + bumpWidth > coords.end.y) {
                let thisBumpWidth = coords.end.y - lastY,
                    thisBumpHeight = (thisBumpWidth / bumpWidth) * bumpHeight;
                ct.bezierCurveTo(lastX + thisBumpHeight, lastY + (thisBumpWidth / 2), lastX + thisBumpHeight, lastY + (thisBumpWidth / 2), lastX, coords.end.y);
                lastY = coords.end.y;
            } else {
                ct.bezierCurveTo(lastX + bumpHeight, lastY + bumpWidthHalf, lastX + bumpHeight, lastY + bumpWidthHalf, lastX, lastY + bumpWidth);
                lastY += bumpWidth;
            }
        }
        while (lastX > coords.start.x) {
            if (lastX - bumpWidth < coords.start.x) {
                let thisBumpWidth = lastX - coords.start.x,
                    thisBumpHeight = (thisBumpWidth / bumpWidth) * bumpHeight;
                ct.bezierCurveTo(lastX - (thisBumpWidth / 2), lastY + thisBumpHeight, lastX - (thisBumpWidth / 2), lastY + thisBumpHeight, coords.start.x, lastY);
                lastX = coords.start.x;
            } else {
                ct.bezierCurveTo(lastX - bumpWidthHalf, lastY + bumpHeight, lastX - bumpWidthHalf, lastY + bumpHeight, lastX - bumpWidth, lastY);
                lastX -= bumpWidth;
            }
        }
        while (lastY > coords.start.y) {
            if (lastY - bumpWidth < coords.start.y) {
                let thisBumpWidth = lastY - coords.start.y,
                    thisBumpHeight = (thisBumpWidth / bumpWidth) * bumpHeight;
                ct.bezierCurveTo(lastX - thisBumpHeight, lastY - (thisBumpWidth / 2), lastX - thisBumpHeight, lastY - (thisBumpWidth / 2), lastX, coords.start.y);
                lastY = coords.start.y;
            } else {
                ct.bezierCurveTo(lastX - bumpHeight, lastY - bumpWidthHalf, lastX - bumpHeight, lastY - bumpWidthHalf, lastX, lastY - bumpWidth);
                lastY -= bumpWidth;
            }
        }
        ct.closePath();

        this.stroke(ct, scale);

        if (typeof this.drawLink === 'function') {
            this.drawLink(ct, scale);
        }
    }
});

PJQ.models.drawings.Text = PJQ.models.drawings.Rectangle.extend({
    beforeConstruct: function (attributes) {
        attributes.text = attributes.text != null ? attributes.text : "";
        attributes.textSize = attributes.textSize != null ? attributes.textSize : 100;
    },
    getDisplayName: function () {
        return PJQ.constants.drawings.annotationTypeNames.TEXT;
    },
    getTextSize: function (scale = 1) {
        let ts = this.get('textSize');
        return (60 * ((ts ? ts : 100) / 100) / scale);
    },
    draw: function (ct, scale, options = {}) {
        let coords = this.getCoords(scale);
        if (coords == null) {
            return;
        }

        let textSize = this.getTextSize(scale);
        ct.beginPath();
        ct.fillStyle = this.getStrokeColor();
        ct.font = textSize + 'px Roboto';

        // we start the y position at y + textsize because
        // the y coordinate of text is at the bottom of the characters
        let y = coords.start.y + textSize,
            words = this.attributes.text.split(' '),
            line = '';
        for (let n = 0; n < words.length; n++) {
            let testLine = line + words[n],
                metrics = ct.measureText(testLine + ' '),
                testWidth = metrics.width;
            if (testWidth > coords.width && n > 0) {
                ct.fillText(line, coords.start.x, y);
                line = words[n] + ' ';
                y += textSize;
            } else {
                line = testLine + ' ';
            }
        }
        ct.fillText(line, coords.start.x, y);

        if (options.isDrawing) {
            ct.beginPath();
            ct.rect(coords.start.x, coords.start.y, coords.width, coords.height);
            ct.setLineDash([6]);
            ct.lineWidth = 6 / scale;
            ct.strokeStyle = '#343a40';
            ct.stroke();
        }
    }
});

PJQ.models.drawings.Pin = PJQ.models.drawings.Annotation.extend({
    getDisplayName: function () {
        return "";
    },
    end: function (x, y) {
        PJQ.models.drawings.Annotation.prototype.end.call(this, x, y)
        return this.start(x, y);
    },
    move: function (xDiff, yDiff, maxX, maxY) {
        let newX = this.attributes.start.x + xDiff,
            newY = this.attributes.start.y + yDiff;
        if (newX < 0) {
            newX = 0;
        } else if (newX > maxX) {
            newX = maxX;
        }

        if (newY < 0) {
            newY = 0;
        } else if (newY > maxY) {
            newY = maxY;
        }

        this.end(newX, newY);
    },
    collides: function (x, y) {
        let start = this.get('start');
        if (start == null) {
            return false;
        }

        let isHf = this.getIconSize() / 2;
        return PJQ.helpers.trigHelpers.checkRectCollision({
            x: start.x - isHf,
            y: start.y - isHf
        }, {
            x: start.x + isHf,
            y: start.y + isHf
        }, x, y);
    },
    getIcon: function () {
        return "\uF041";
    },
    getIconSize: function (scale = 1) {
        return (80 / scale);
    },
    draw: function (ct, scale) {
        let coords = this.getCoords(scale);
        if (coords == null) {
            return;
        }

        let is = this.getIconSize(scale),
            isHf = is / 2,
            font = '900 ' + is + 'px "Font Awesome 5 Pro"';
        ct.beginPath();
        ct.font = font;
        ct.fillStyle = this.getStrokeColor();
        ct.fillText(this.getIcon(), coords.start.x - isHf, coords.start.y + isHf);
    }
});

PJQ.models.drawings.PinRFI = PJQ.models.drawings.Pin.extend({
    getDisplayName: function () {
        return PJQ.constants.drawings.annotationTypeNames.PIN_RFI;
    },
    getIcon: function () {
        return "\uF60b";
    }
});

PJQ.models.drawings.PinPunchListItem = PJQ.models.drawings.Pin.extend({
    getDisplayName: function () {
        let res = PJQ.constants.drawings.annotationTypeNames.PIN_PUNCH_LIST_ITEM;
        if (this.punchListItem != null) {
            res += ' #' + this.punchListItem.get('itemNumber');
        }
        return res
    },
    getIcon: function () {
        return "\uF606";
    },
    getStrokeColor: function () {
        if (this.punchListItem != null) {
            return this.punchListItem.getStatusColor();
        }
        return PJQ.models.drawings.Pin.prototype.getStrokeColor.call(this);
    },
    getFillColor: function () {
        if (this.punchListItem != null) {
            return this.punchListItem.getStatusColor() + '75';
        }
        return PJQ.models.drawings.Pin.prototype.getFillColor.call(this);
    },
    getDeepLink: function () {
        return this.punchListItem?.getDeepLink();
    },
    setPunchListItem: function (item) {
        this.set({
            refId: item.id,
            refType: PJQ.constants.drawings.refTypes.PUNCH_LIST_ITEM,
            refData: {
                id: item.id,
                title: item.get('title'),
                itemNumber: item.get('itemNumber'),
                status: item.get('status'),
            },
            isDirty: true
        });
        this.punchListItem = item;
    }
});

PJQ.models.drawings.PinActionItem = PJQ.models.drawings.Pin.extend({
    getDisplayName: function () {
        let res = PJQ.constants.drawings.annotationTypeNames.PIN_ACTION_ITEM;
        if (this.actionItem != null) {
            res += ' #' + this.actionItem.get('itemNumber');
        }
        return res
    },
    getIcon: function () {
        return "\uF608";
    },
    getStrokeColor: function () {
        if (this.actionItem != null) {
            return this.actionItem.getStatusColor();
        }
        return PJQ.models.drawings.Pin.prototype.getStrokeColor.call(this);
    },
    getFillColor: function () {
        if (this.actionItem != null) {
            return this.actionItem.getStatusColor() + '75';
        }
        return PJQ.models.drawings.Pin.prototype.getFillColor.call(this);
    },
    getDeepLink: function () {
        return this.actionItem?.getDeepLink();
    },
    setActionItem: function (item) {
        this.set({
            refId: item.id,
            refType: PJQ.constants.drawings.refTypes.ACTION_ITEM,
            refData: {
                id: item.id,
                title: item.get('title'),
                itemNumber: item.get('itemNumber'),
                status: item.get('status'),
            },
            isDirty: true
        });
        this.actionItem = item;
    },
});

PJQ.models.drawings.PinSubmittal = PJQ.models.drawings.Pin.extend({
    getDisplayName: function () {
        return PJQ.constants.drawings.annotationTypeNames.PIN_SUBMITTAL;
    },
    getIcon: function () {
        return "\uF041";
    }
});

PJQ.models.drawings.Photo = PJQ.models.drawings.Pin.extend({
    getDisplayName: function () {
        return PJQ.constants.drawings.annotationTypeNames.PHOTO;
    },
    getIcon: function () {
        return "\uF030";
    }
});

PJQ.models.drawings.LinkRectangle = PJQ.models.drawings.Rectangle.extend({
    getDisplayName: function () {
        return PJQ.constants.drawings.annotationTypeNames.LINK_RECTANGLE;
    },
    drawLink: function (ct, scale) {
        let coords = this.getCoords(scale);
        if (coords == null) {
            return null;
        }

        let is = (80 / scale),
            isHf = is / 2,
            font = '900 ' + is + 'px "Font Awesome 5 Pro"';
        document.fonts.load(font).then((_) => {
            ct.beginPath();
            ct.font = font;
            ct.fillStyle = this.getStrokeColor();
            ct.fillText("\uf0c1", coords.start.x + isHf, coords.end.y - isHf);
        })
    }
});

PJQ.models.drawings.LinkEllipse = PJQ.models.drawings.Ellipse.extend({
    getDisplayName: function () {
        return PJQ.constants.drawings.annotationTypeNames.LINK_ELLIPSE;
    },
    drawLink: function (ct, scale) {
        let coords = this.getCoords(scale);
        if (coords == null) {
            return null;
        }

        let is = (80 / scale),
            isHf = is / 2,
            font = '900 ' + is + 'px "Font Awesome 5 Pro"';
        document.fonts.load(font).then((_) => {
            let x = coords.start.x + (coords.width / 2),
                y = coords.end.y
            ct.beginPath();
            ct.font = font;
            ct.fillStyle = this.getStrokeColor();
            ct.fillText("\uf0c1", x - isHf, y - isHf);
        })
    }
});

PJQ.models.drawings.LinkCloud = PJQ.models.drawings.Cloud.extend({
    getDisplayName: function () {
        return PJQ.constants.drawings.annotationTypeNames.LINK_CLOUD;
    },
    drawLink: PJQ.models.drawings.LinkRectangle.prototype.drawLink
});

PJQ.models.drawings.Ruler = PJQ.models.drawings.Line.extend({
    getDisplayName: function () {
        return PJQ.constants.drawings.annotationTypeNames.RULER;
    },
    draw: function (ct, scale, options) {
        let coords = this.getCoords(scale);
        if (coords == null) {
            return;
        }

        // draw the line with a gap in the middle for the length text
        // to do this, we find 2 points offset "gap" pixels in either direction (scaled) from the center point of the line
        // we then draw 2 lines, 1 from the start to center offset 1 - the other from center offset 2 to the end
        let dx = coords.start.x - coords.end.x,
            dy = coords.start.y - coords.end.y,
            len = Math.sqrt(dx * dx + dy * dy) / 2,
            gap = Math.min(50, len / 4),
            textSize = (gap * 0.8) / scale,
            d1 = len - (gap / scale),
            d2 = len + (gap / scale),
            angle = Math.atan2(coords.end.y - coords.start.y, coords.end.x - coords.start.x),
            middle1 = {
                x: coords.start.x + d1 * Math.cos(angle),
                y: coords.start.y + d1 * Math.sin(angle)
            },
            middle2 = {
                x: coords.start.x + d2 * Math.cos(angle),
                y: coords.start.y + d2 * Math.sin(angle)
            };
        ct.beginPath();
        ct.moveTo(coords.start.x, coords.start.y);
        ct.lineTo(middle1.x, middle1.y);
        ct.moveTo(middle2.x, middle2.y);
        ct.lineTo(coords.end.x, coords.end.y);
        this.stroke(ct, scale);

        // write the ruler calculated length
        // we start the y position at y + textsize because
        // the y coordinate of text is at the bottom of the characters
        let rulerLength = this.getRulerLength(options.drawing.get('scale')),
            scaleType = options.drawing.get('scaleType'),
            rulerText = '';
        if (scaleType === PJQ.constants.drawings.scaleTypes.IMPERIAL) {
            let inches = rulerLength,
                feet = 0;
            if (inches > 12) {
                feet = Math.floor(inches / 12);
                rulerText = feet.toString() + "' " + (inches % 12).toString() + "\"";
            } else {
                rulerText = inches.toString() + "\"";
            }
        } else {

        }

        ct.beginPath();
        ct.fillStyle = this.getStrokeColor();
        ct.font = textSize + 'px Roboto';
        ct.fillText(rulerText, middle1.x, middle1.y);
    },
    getRulerLength: function (scale) {
        let start = this.get('start'),
            end = this.get('end'),
            dx = end.x - start.x,
            dy = end.y - start.y,
            d = Math.sqrt(dx * dx + dy * dy);
        return Math.round(d / scale);
    }
});

PJQ.models.drawings.AreaRectangle = PJQ.models.drawings.Rectangle.extend({
    getDisplayName: function () {
        return PJQ.constants.drawings.annotationTypeNames.AREA_RECT;
    }
});

PJQ.models.drawings.RulerFreeForm = PJQ.models.drawings.Pen.extend({
    getDisplayName: function () {
        return PJQ.constants.drawings.annotationTypeNames.RULER_FREE_FORM;
    }
});

PJQ.models.drawings.AreaFreeForm = PJQ.models.drawings.Pen.extend({
    getDisplayName: function () {
        return PJQ.constants.drawings.annotationTypeNames.AREA_FREE_FORM;
    }
});

PJQ.models.drawings.AnnotationAttachment = PJQ.models.files.File.extend({
    idAttribute: 'attachmentId',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'drawings'
            },
            {
                endpoint: 'annotations',
                value: this.get('annotationId')
            },
            {
                endpoint: 'attachments',
                value: this.id
            }
        ]);
    }
});

PJQ.collections.drawings.Layers = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.drawings.Layer,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.options.projectId
            },
            {
                endpoint: 'layers'
            }
        ]);
    },
    fetchAnnotations: function (drawingId, callback) {
        if (_.indexOf(this.fetchedDrawingIds, drawingId) === -1) {
            if (this.fetchedDrawingIds == null) {
                this.fetchedDrawingIds = [drawingId];
            } else {
                this.fetchedDrawingIds.push(drawingId);
            }
            new PJQ.ajax.Request({
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'drawings',
                        value: drawingId
                    },
                    {
                        endpoint: 'annotations'
                    }
                ])
            }).get().done(_.bind(function (annotations) {
                _.each(annotations, function (annotation) {
                    let layer = this.get(annotation.layerId);
                    if (layer != null) {
                        layer.annotations.add(annotation);
                    }
                }, this);
                callback();
            }, this)).fail(_.bind(function () {
                callback();
            }, this));
        } else {
            callback();
        }
    }
});

PJQ.collections.drawings.Annotations = PJQ.collections.BaseCollection.extend({
    afterInit: function () {
        if (PJQ.helpers.objectHelpers.checkNested(PJQ.app, 'session', 'preferences')) {
            this.options.isAPIv2 = PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_DRAWING_ANNOTATION_REFS);
        }
    },
    model: function (attrs, options) {
        let mod;
        switch (attrs.type.toUpperCase()) {
            case PJQ.constants.drawings.annotationTypes.LINE:
                mod = PJQ.models.drawings.Line;
                break;
            case PJQ.constants.drawings.annotationTypes.PEN:
                mod = PJQ.models.drawings.Pen;
                break;
            case PJQ.constants.drawings.annotationTypes.HIGHLIGHTER:
                mod = PJQ.models.drawings.Highlighter;
                break;
            case PJQ.constants.drawings.annotationTypes.ARROW:
                mod = PJQ.models.drawings.Arrow;
                break;
            case PJQ.constants.drawings.annotationTypes.RECTANGLE:
                mod = PJQ.models.drawings.Rectangle;
                break;
            case PJQ.constants.drawings.annotationTypes.ELLIPSE:
                mod = PJQ.models.drawings.Ellipse;
                break;
            case PJQ.constants.drawings.annotationTypes.CLOUD:
                mod = PJQ.models.drawings.Cloud;
                break;
            case PJQ.constants.drawings.annotationTypes.LINK_RECTANGLE:
                mod = PJQ.models.drawings.LinkRectangle;
                break;
            case PJQ.constants.drawings.annotationTypes.LINK_ELLIPSE:
                mod = PJQ.models.drawings.LinkEllipse;
                break;
            case PJQ.constants.drawings.annotationTypes.LINK_CLOUD:
                mod = PJQ.models.drawings.LinkCloud;
                break;
            case PJQ.constants.drawings.annotationTypes.TEXT:
                mod = PJQ.models.drawings.Text;
                break;
            case PJQ.constants.drawings.annotationTypes.PHOTO:
                mod = PJQ.models.drawings.Photo;
                break;
            case PJQ.constants.drawings.annotationTypes.RULER:
                mod = PJQ.models.drawings.Ruler;
                break;
            case PJQ.constants.drawings.annotationTypes.AREA_RECT:
                mod = PJQ.models.drawings.AreaRectangle;
                break;
            case PJQ.constants.drawings.annotationTypes.RULER_FREE_FORM:
                mod = PJQ.models.drawings.RulerFreeForm;
                break;
            case PJQ.constants.drawings.annotationTypes.AREA_FREE_FORM:
                mod = PJQ.models.drawings.AreaFreeForm;
                break;
            case PJQ.constants.drawings.annotationTypes.PIN_RFI:
                mod = PJQ.models.drawings.PinRFI;
                break;
            case PJQ.constants.drawings.annotationTypes.PIN_PUNCH_LIST_ITEM:
                mod = PJQ.models.drawings.PinPunchListItem;
                break;
            case PJQ.constants.drawings.annotationTypes.PIN_ACTION_ITEM:
                mod = PJQ.models.drawings.PinActionItem;
                break;
            case PJQ.constants.drawings.annotationTypes.PIN_SUBMITTAL:
                mod = PJQ.models.drawings.PinSubmittal;
                break;
            default:
                mod = PJQ.models.drawings.Annotation;
                break;
        }
        return new mod(attrs, options)
    },
    merge: function (mergeAnnotations, contextId) {
        let fnMerge = (annotation) => {
            if ((contextId == null || annotation.get('contextId') === contextId) && (this.options.drawingId == null || this.options.drawingId === annotation.get('drawingId'))) {
                if (annotation.id > 0) {
                    let exist = this.findWhere({annotationId: annotation.id});
                    if (exist != null) {
                        this.remove(exist.cid);
                    }
                }
                this.add(annotation);
            }
        }
        if (PJQ.helpers.objectHelpers.refinedType(mergeAnnotations) === 'array') {
            _.each(mergeAnnotations, (annotation) => {
                fnMerge(annotation);
            });
        } else {
            fnMerge(mergeAnnotations);
        }
    },
    endpoint: function (options) {
        if (!options) {
            options = {};
        }

        options.isAPIv2 = this.options.isAPIv2 = [PJQ.constants.drawings.annotationTypes.PIN_RFI,
            PJQ.constants.drawings.annotationTypes.PIN_PUNCH_LIST_ITEM,
            PJQ.constants.drawings.annotationTypes.PIN_ACTION_ITEM,
            PJQ.constants.drawings.annotationTypes.PIN_SUBMITTAL].indexOf(this.get('type')) !== -1;

        let params;
        if (_.size(this.options.context) > 0 && this.options.contextId > 0) {
            params = [{
                parameter: 'context',
                value: this.options.context
            }, {
                parameter: 'contextId',
                value: this.options.contextId
            }];
        } else {
            params = [];
        }

        if (this.options.accessKey != null) {
            params.push({
                parameter: 'accessKey',
                value: this.options.accessKey
            });
        }

        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'drawings',
                value: this.options.drawingId
            },
            {
                endpoint: 'annotations'
            }
        ], params);
    },
    saveAll: function (callback) {
        let annotationsMap = {};
        _.each(this.models, (annotation) => {
            if (annotationsMap[annotation.get('drawingId')] == null) {
                annotationsMap[annotation.get('drawingId')] = [];
            }
            annotation.beforeSave();
            annotationsMap[annotation.get('drawingId')].push(annotation);
        });

        let saveAnnotations = _.map(annotationsMap, function (annotations) {
            return annotations;
        });
        let changedCt = _.size(saveAnnotations),
            saveNextAnnotation = (i) => {
                if (changedCt < i + 1) {
                    if (typeof callback === 'function') {
                        callback();
                    }
                    return;
                }
                let thisSet = saveAnnotations[i];
                if (_.size(thisSet) > 0) {
                    let drawingId = thisSet[0].get('drawingId');
                    new PJQ.ajax.Request({
                        endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                            {
                                endpoint: 'drawings',
                                value: drawingId
                            },
                            {
                                endpoint: 'annotations'
                            }
                        ]),
                        data: thisSet
                    }).put().done(_.bind(function (response) {
                        saveNextAnnotation(i + 1);
                    }, this));
                } else {
                    saveNextAnnotation(i + 1);
                }
            };
        saveNextAnnotation(0);
    }
});

PJQ.collections.drawings.AnnotationAttachments = PJQ.collections.files.Files.extend({
    model: PJQ.models.drawings.AnnotationAttachment
});